import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTopMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTopMedium"><Path d="M19.3105 14.5L18.25 15.5605L12 9.31055L5.75 15.5605L4.68945 14.5L12 7.18945L19.3105 14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTopMedium;
